import classNames from "classnames";
import { forwardRef, ThHTMLAttributes } from "react";

export const TableHead = forwardRef<
  HTMLTableCellElement,
  ThHTMLAttributes<HTMLTableCellElement>
>(({ className, ...props }: ThHTMLAttributes<HTMLTableCellElement>, ref) => (
  <th
    ref={ref}
    className={classNames(
      "g-table__cell g-table__cell_edge-padding",
      className,
    )}
    {...props}
  />
));
TableHead.displayName = "TableHead";
